import { ControlProps, isDateControl, rankWith } from '@jsonforms/core'
import { withJsonFormsControlProps } from '@jsonforms/react'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { DateInput } from 'elements/input/DateInput'
import { ComponentVersionsInherit, ComponentVersions_2_0, Typography, styled } from 'opensolar-ui'
import * as React from 'react'
import { useCallback, useMemo } from 'react'

dayjs.extend(customParseFormat)

const tester = rankWith(100, isDateControl)

const DAYJS_FORMAT = 'MM/DD/YYYY'

const StyledDateInput = styled(DateInput)({
  '& .MuiOutlinedInput-input': {
    padding: '12.5px 12px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderWidth: '1px',
  },
})

const Renderer: React.FC<ControlProps> = (props) => {
  const { data, handleChange, path, label, visible, enabled, uischema, required, config } = props
  const integration = React.useMemo(() => config?.integration || 'unknown', [config])
  const variant = React.useMemo(() => (integration === 'propensio' ? 'outlined' : 'standard'), [integration])
  const labelText = React.useMemo(() => (integration === 'propensio' ? null : label), [integration, label])
  const DISPLAY_FORMAT = React.useMemo(() => (integration === 'propensio' ? 'dd/MM/yyyy' : 'MM/dd/yyyy'), [integration])

  const displayFormat = uischema?.options?.displayFormat || DISPLAY_FORMAT
  const dataFormat = uischema?.options?.format || DAYJS_FORMAT

  const value = useMemo(() => {
    if (!data) return null
    const parsed = dayjs(data, dataFormat, true)
    return parsed.isValid() ? parsed : dayjs(data)
  }, [data, dataFormat])

  const handleDateChange = useCallback(
    (date: Date | null) => {
      const formattedDate = date ? dayjs(date).format(dataFormat) : null
      handleChange(path, formattedDate)
    },
    [handleChange, path, dataFormat]
  )

  return (
    <ComponentVersionsInherit versions={ComponentVersions_2_0}>
      <div style={{ display: visible ? 'block' : 'none' }}>
        {integration === 'propensio' && (
          <div style={{ marginBottom: '2px', marginTop: '8px' }}>
            <Typography variant="h6">Date of Birth</Typography>
          </div>
        )}
        <StyledDateInput
          openTo="year"
          value={value}
          format={displayFormat}
          onYearChange={() => {}}
          label={labelText as string}
          onChange={handleDateChange}
          autoOk
          disableToolbar
          fullWidth
          disabled={!enabled}
          required={required}
          width="100%"
          inputVariant={variant}
          size="medium"
        />
      </div>
    </ComponentVersionsInherit>
  )
}

const renderer = withJsonFormsControlProps(Renderer)

export default {
  tester,
  renderer,
}
